import React from "react";
import styles from "@/components/telemetry/detail/BodyViewer.module.css";

interface BodyViewerProps {
  body: string | null;
  title: string;
}

function tryFormatJson(text: string): string {
  try {
    return JSON.stringify(JSON.parse(text), null, 2);
  } catch {
    return text;
  }
}

function BodyViewer({ body, title }: BodyViewerProps) {
  if (!body) return null;

  return (
    <div className={styles.container}>
      <h3 className={styles.title}>{title}</h3>
      <pre className={styles.body}>{tryFormatJson(body)}</pre>
    </div>
  );
}

export default BodyViewer;
